export default __webpack_public_path__ + "static/media/ganharSeguidores.313506ed.svg";